import { OnInit } from '@angular/core';
import Swal from "sweetalert2";
import { PROJECT_MESSAGES } from "../../config/project";
import * as i0 from "@angular/core";
import * as i1 from "ngx-mask";
import * as i2 from "../../service/phoneMask.service";
var PopupComponent = /** @class */ (function () {
    function PopupComponent(maskApplierService, phoneMaskService) {
        this.maskApplierService = maskApplierService;
        this.phoneMaskService = phoneMaskService;
        this.phoneMask = this.phoneMaskService.setPhoneMask();
        this.swalStyled = Swal.mixin({
            customClass: {
                container: 'popup',
                popup: 'popup__inner',
                image: 'popup__image',
                title: 'popup__title',
                content: 'popup__content',
                confirmButton: 'popup__btn popup__btn_confirm snake-btn is-notouched',
                cancelButton: 'popup__btn popup__btn_cancel'
            },
        });
    }
    PopupComponent.prototype.ngOnInit = function () {
    };
    PopupComponent.prototype.showPopupSuccess = function (message) {
        this.swalStyled.fire({
            showClass: {
                popup: 'swal-success'
            },
            text: message.text ? message.text : 'The action was successful!',
            confirmButtonText: 'OK, THANKS',
        });
    };
    PopupComponent.prototype.showPopupError = function (message) {
        var text = message.text ? message.text : 'Oops! Something is not right.';
        var confirmButtonText = message.confirmButtonText ? message.confirmButtonText : 'BACK';
        var closeBtn = message.closeBtn === false ? message.closeBtn : true;
        this.swalStyled.fire({
            // title: 'Error',
            // imageUrl: '../assets/images/popup/error-logo.png',
            //className: "swal-back",
            showClass: {
                popup: 'swal-error'
            },
            text: text,
            showConfirmButton: closeBtn,
            allowOutsideClick: closeBtn,
            confirmButtonText: confirmButtonText
        });
    };
    PopupComponent.prototype.showPopupTryAgain = function () {
        this.swalStyled.fire({
            showClass: {
                popup: 'swal-error'
            },
            text: PROJECT_MESSAGES.unknownError,
            confirmButtonText: 'BACK'
        });
    };
    PopupComponent.prototype.showPopupAgreement = function (options, handler) {
        var text = options.text ? options.text : 'Something went wrong. Please try again.';
        var confirmButtonText = options.confirmButtonText ? options.confirmButtonText : 'CONFIRM<svg><rect></rect></svg>';
        var cancelButtonText = options.cancelButtonText ? options.cancelButtonText : '<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M25.5 24.1719L18.3281 17L25.5 9.82812C25.8668 9.46136 25.8668 8.86676 25.5 8.5C25.1332 8.13324 24.5386 8.13324 24.1719 8.5L17 15.6719L9.82813 8.5C9.46136 8.13324 8.86676 8.13324 8.5 8.5C8.13324 8.86676 8.13324 9.46136 8.5 9.82812L15.6719 17L8.5 24.1719C8.13324 24.5386 8.13324 25.1332 8.5 25.5C8.86676 25.8668 9.46136 25.8668 9.82813 25.5L17 18.3281L24.1719 25.5C24.5386 25.8668 25.1332 25.8668 25.5 25.5C25.8668 25.1332 25.8668 24.5386 25.5 24.1719Z" fill="#FDFD88"/>\n' +
            '</svg>';
        var showConfirmButton = options.showConfirmButton === false ? options.showConfirmButton : true;
        this.swalStyled.fire({
            showClass: {
                popup: 'swal-agreement',
            },
            html: text,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            showCancelButton: true,
            showConfirmButton: showConfirmButton,
        }).then(function (result) {
            if (result.isConfirmed) {
                return handler(true);
            }
            else {
                return handler(false);
            }
        });
    };
    PopupComponent.prototype.showPopupInput = function (options, handler) {
        var _this = this;
        var text = options.text ? options.text : 'Please enter your phone number';
        var style = options.style ? options.style : 'swal-choice';
        var confirmButtonText = options.confirmButtonText ? options.confirmButtonText : 'CONFIRM<svg><rect></rect></svg>';
        var cancelButtonText = options.cancelButtonText ? options.cancelButtonText : 'No<svg><rect></rect></svg>';
        this.swalStyled.fire({
            showClass: {
                popup: style,
            },
            html: text,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            allowOutsideClick: true,
            allowEscapeKey: false,
            showCancelButton: false,
            input: 'tel',
            inputValidator: function (value) {
                if (!value) {
                    return 'You need to write something!';
                }
                else if (value.length !== _this.phoneMask.length) {
                    return "Entered phone number isn't valid";
                }
            },
            onBeforeOpen: function () {
                _this.swalStyled.getInput().addEventListener('input', function (event) {
                    if (!Number.isInteger(parseInt((event['data']))) && event['inputType'] === "insertText") {
                        setTimeout(function () {
                            _this.swalStyled.getInput().value = _this.swalStyled.getInput().value.slice(0, -1);
                        });
                        // return false;
                    }
                    else {
                        _this.swalStyled.getInput().maxLength = _this.phoneMask.length;
                        var maskedValue = _this.maskApplierService.applyMask(_this.swalStyled.getInput().value.trim(), _this.phoneMask);
                        _this.swalStyled.getInput().value = maskedValue;
                    }
                });
            },
        }).then(function (result) {
            if (result.isConfirmed) {
                return handler(_this.swalStyled.getInput().value);
            }
            else {
                return handler(false);
            }
        });
    };
    PopupComponent.prototype.closePopup = function () {
        this.swalStyled.close();
    };
    PopupComponent.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PopupComponent_Factory() { return new PopupComponent(i0.ɵɵinject(i1.MaskApplierService), i0.ɵɵinject(i2.PhoneMaskService)); }, token: PopupComponent, providedIn: "root" });
    return PopupComponent;
}());
export { PopupComponent };
